import { jsx as _jsx } from "react/jsx-runtime";
import i18next from 'i18next';
import { useDrawer } from '@famly/mf_modals-dialogs_context';
import { KinderConnectCaptureDetailDrawerSkeleton } from './kinder-connect-capture-detail-drawer-skeleton';
const loadKinderConnectCaptureDetailDrawerContent = () => import('./kinder-connect-capture-detail-drawer-content');
/**
 * Opens the KinderConnect capture detail viewer as a right-anchored Modern Famly drawer.
 *
 * Rendered via `useDrawer` (rather than nesting an MF `Drawer` directly) so it reliably stacks on
 * top of whatever modal/dialog it's opened from -- the child attendance modal in particular, which
 * shares the same default z-index as a directly-nested `Drawer` and would otherwise fight it for
 * paint order.
 */
export const useKinderConnectCaptureDetailDrawer = () => {
    const { showDrawer, hideDrawer } = useDrawer({
        lazyChildren: loadKinderConnectCaptureDetailDrawerContent,
        title: {
            text: i18next.t($ => $.stat.kinderConnectCapture.businessLogic.src.translations.json.captureDetail.drawerTitle),
        },
        maxWidth: '472px',
        skeleton: _jsx(KinderConnectCaptureDetailDrawerSkeleton, {}),
    });
    return {
        showKinderConnectCaptureDetailDrawer: showDrawer,
        hideKinderConnectCaptureDetailDrawer: hideDrawer,
    };
};
